// extracted by mini-css-extract-plugin
export default {"inputWrapper":"DateInput_inputWrapper__dR7jV","label":"DateInput_label__ziJwc","input":"DateInput_input__-dgmY","errorMessage":"DateInput_errorMessage__ob5bI"};